module.exports = __webpack_public_path__ + "static/media/icon-hot.ea8d4a86.png";